import type { QualityRisk } from '~/gql/quality/quality'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { Button } from '~/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/components/ui/table'
import { RISK_STATUS_KEYS, severityVariant } from './quality-labels'

type IProps = {
  risks: readonly QualityRisk[]
  formatDate: (value: unknown) => string
  onOpen: (risk: QualityRisk) => void
}

/** Une ligne par risque (#328), du plus grave au moins grave : sa cote, son état, sa dernière revue. */
function QualityRisksTable({ risks, formatDate, onOpen }: IProps) {
  const { t } = useTranslation()

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('quality.column.title')}</TableHead>
          <TableHead>{t('quality.risks.column.severity')}</TableHead>
          <TableHead>{t('quality.column.status')}</TableHead>
          <TableHead>{t('quality.risks.column.reviewedAt')}</TableHead>
          <TableHead><span className="sr-only">{t('quality.column.actions')}</span></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {risks.map(r => (
          <TableRow key={r.id}>
            <TableCell>
              <div className="flex min-w-0 flex-col">
                <span className="font-medium">{r.title}</span>
                {r.owner && <span className="text-xs text-muted-foreground">{r.owner}</span>}
              </div>
            </TableCell>
            <TableCell>
              <Badge variant={severityVariant(r.severity)}>{t('quality.risks.severityValue', { severity: r.severity, likelihood: r.likelihood, impact: r.impact })}</Badge>
            </TableCell>
            <TableCell>{t(RISK_STATUS_KEYS[r.status])}</TableCell>
            <TableCell className="whitespace-nowrap">{formatDate(r.updatedAt)}</TableCell>
            <TableCell className="text-right">
              <Button variant="outline" size="sm" onClick={() => onOpen(r)} aria-label={t('common.actionFor', { action: t('quality.open'), name: r.title })}>
                {t('quality.open')}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default QualityRisksTable
